const defaultStyles = `
`;

export const types = {
  headers: {
    main: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 64px;
    `,
    main52: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 52px;
    `,
    main42: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 42px;
    `,
    main36: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 36px;
    `,
    main30: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 30px;
    `,
    secondary: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 48px;
    `,
    section: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 32px;
    `,
    item: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 21.4px;
    `,
    itemMedium: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 20px;
    `,
    small: `
    ${defaultStyles}
    font-weight: 700;
    font-size: 18px;
  `,
    xSmall: `
      ${defaultStyles}
      font-weight: 700;
      font-size: 16px;
    `,
    normal: `
    ${defaultStyles}
    font-weight: 700;
    font-size: 14px;
  `,
  },
  body: {
    title: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 32px;
    `,
    secondaryTitle: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 24px;
    `,
    smallTitle: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 22px;
    `,
    mediumSubtitle: `
    ${defaultStyles}
    font-weight: 400;
    font-size: 18px;
  `,
    subtitle: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 16px;
    `,
    normal: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 14px;
    `,
    label: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 16px;
    `,
    small: `
      ${defaultStyles}
      font-weight: 400;
      font-size: 12px;
    `,
    extraSmall: `
    ${defaultStyles}
    font-weight: 400;
    font-size: 10px;
  `,
  },
};
